<div [formGroup]="docForm" class="container-panel">
  <h4>
    {{ 'Doc::CustomerQuote:Configuration' | abpLocalization }}
  </h4>
  <div class="card-group header card-col">
    <div class="card">
      <div class="row row-cols-1 row-cols-md-5">
        <div class="col">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="retainBackOrders"
              formControlName="retainBackOrders"
            />
            <label for="retainBackOrders" class="form-check-label text-primary">
              {{ 'Doc::CustomerQuote:BackOrder' | abpLocalization }}
            </label>
          </div>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-5">
        <div class="col-12 col-md-2">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="litigation"
              formControlName="litigation"
            />
            <label for="litigation" class="form-check-label text-primary">
              {{ 'Doc::CustomerQuote:Litigation' | abpLocalization }}
            </label>
          </div>
        </div>
        @if (docForm.controls.litigation.value) {
          <div class="col">
            <div>
              <label for="litigationReason" class="form-label text-primary">
                {{ 'Doc::CustomerQuote:LitigationReason' | abpLocalization }}
              </label>
              <input
                type="text"
                id="litigationReason"
                class="form-control"
                formControlName="litigationReason"
                [DwInput]
              />
            </div>
          </div>
        }
      </div>

      <div class="row row-cols-1 row-cols-md-5">
        <div class="col-12 col-md-2">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="isBlocked"
              formControlName="isBlocked"
            />
            <label for="isBlocked" class="form-check-label text-primary">
              {{ 'Doc::CustomerQuote:IsBlocked' | abpLocalization }}
            </label>
          </div>
        </div>
        @if (docForm.controls.isBlocked.value) {
          <div class="col">
            <div class="col-12">
              <label for="blockedReason" class="form-label text-primary">
                {{ 'Doc::CustomerQuote:BlockedReason' | abpLocalization }}
              </label>
              <input
                type="text"
                id="blockedReason"
                class="form-control"
                formControlName="blockedReason"
                [DwInput]
              />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div [formGroup]="docForm" class="container-panel">
  <h4>
    {{ 'Doc::DayBook:PrintTemplates' | abpLocalization }}
  </h4>
  <div class="card-group header card-col">
    <div class="card">
      <div class="row row-cols-1 row-cols-md-5">
        <div class="col col-md-4">
          <label for="preferredPrintTemplateId" class="form-label text-primary">
            {{ 'Doc::DayBook:PrintTemplates' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="preferredPrintTemplateId"
            formControlName="preferredPrintTemplateId"
            bindLabel="name"
            bindValue="id"
            [items]="docPrintTemplatesTypeStore.entities()"
          >
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</div>

@if (docRoleInput != docRole.SupplierDeliveryNote) {
  <div [formGroup]="docForm" class="container-panel">
    <h4>
      {{ 'Doc::SupplierQuote:DeliveryPickUp' | abpLocalization }}
    </h4>
    <div class="card-group header card-col">
      <div class="card">
        <div class="row row-cols-1 row-cols-md-5">
          <div class="col col-md-4">
            <label for="deliveryVehicleId" class="form-label text-primary">
              {{ 'Doc::SupplierQuote:PickUpVehicle' | abpLocalization }}
            </label>
            <ng-select
              class="form-control"
              id="deliveryVehicleId"
              formControlName="deliveryVehicleId"
              bindLabel="name"
              bindValue="id"
              [items]="vehicles"
            >
            </ng-select>
          </div>
          <div class="col col-md-4">
            <label for="deliveryInfo" class="text-primary">
              {{ 'Doc::SupplierQuote:DeliveryPickUpInfo' | abpLocalization }}
            </label>
            <input
              type="text"
              id="deliveryInfo"
              class="form-control"
              formControlName="deliveryInfo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
}
